import React, { useState, useEffect, useMemo } from 'react'
import Card from 'react-bootstrap/Card';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import Helpers from '../../Components/Helpers/Helpers';
import { toast } from 'react-toastify'
import FormCustom from '../../Components/Form/FormCustom';
import Select from '../../Components/Form/Select';
import Button from 'react-bootstrap/esm/Button';

const CustomersNew = _ => {
    const [isProcessing, setIsProccesing] = useState(false)
    const [rows, setRows] = useState([])
    const [periodSelected, setPeriodSelected] = useState('')
    const [period, setPeriod] = useState([])
    useEffect(() => {
        Controllers.period.get_period().then(res => {
            setPeriod(res.data)
        })
    }, [])

    const handleSubmit = _ => {
        setIsProccesing(true)
        Controllers.customers.get_customers_new({
            p_id_period: periodSelected
        }).then(res => {
            setRows(res.data)
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setIsProccesing(false)
            })
    }

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        head={[
            [
                { name: 'id_customers', text: 'ID', align: 'center' },
                { name: 'full_name_customers', text: 'Nombres', align: 'center' },
                { name: 'name_price', text: 'Tipo', align: 'center' },
                { name: 'date_registration', text: 'Fecha Registro', align: 'center' },
                { name: 'name_country', text: 'País', align: 'center' },
                { name: 'type_kit', text: 'Kit Comprado', align: 'center' },
                { name: 'phone_customers', text: 'Telefono', align: 'center' },
                { name: 'email_customers', text: 'Email', align: 'center' },
            ],
        ]}
        rows={rows}
        pageLength={100}
        isProcessing={isProcessing}
    />, [rows, isProcessing])

    return <>
        <Card>
            <Card.Header className="justify-content-between">
                <span>Clientes Nuevos</span>
            </Card.Header>
            <Card.Body>
                <FormCustom viewSubmit={false}>
                    <Select
                        text="Periódo"
                        classNameParent="col-12 mb-2"
                        options={period.map(p => {
                            return {
                                label: p.name_period,
                                value: p.id_period
                            }
                        })}
                        onChange={e => setPeriodSelected(e.value)}
                        append={[
                            <Button onClick={handleSubmit}>
                                <i className="fa fa-search"></i>
                            </Button>
                        ]}
                    />
                </FormCustom>
                {dtRows}
            </Card.Body>
        </Card>
    </>
}

export default CustomersNew